/* =================== SLIDE HOME =================== */
jQuery(document).ready(function ($) {
  $(".slide-home")
    .on("init", function () {
      $(".slide-content").show();
    })
    .slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      autoplay: true,
      autoplaySpeed: 5000,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 760,
          settings: {
            dots: false,
            arrows: false,
          },
        },
      ],
    })
    .on("beforeChange", function () {
      $(".slide-content").hide();
    })
    .on("afterChange", function () {
      $(".slide-content").show();
    });
});

// Particulas

$(".particles").each(function (index) {
  particles($(this).attr("id"));
});
